import { EntityBase } from '@provision/entity-types';
import { useMemo } from 'react';
import { CustomAttributeColumnRenderer } from 'src/graphql/entities/custom-view/custom-view-config/custom-attributes-bridge';
import { CustomViewAttribute } from 'src/graphql/entities/custom-view/custom-view.types';
import {
  CustomComponentsByAttribute,
  getAttributeRawValue,
} from 'src/pages/CustomViews/custom-views-entities-table/render-attribute-value';
import { ChipLineItem } from './card-chip-line';
import { CardChipValue } from './card-chip-value';
import { CardLayoutRoles, getChipVisual, isEmptyAttributeValue } from './mobile-card-layout';

export const useCardChipValueItems = <T extends EntityBase>({
  record,
  chips,
  layout,
  customAttributeRenderers,
  customComponentsByAttribute,
}: {
  record: T;
  chips: CustomViewAttribute[];
  layout: CardLayoutRoles;
  customAttributeRenderers?: Map<string, CustomAttributeColumnRenderer>;
  customComponentsByAttribute?: CustomComponentsByAttribute;
}) =>
  useMemo(
    () =>
      chips.flatMap<ChipLineItem>((column) => {
        const customAttributeRenderer = customAttributeRenderers?.get(column.attribute);
        const rawValue = getAttributeRawValue(record, column, customAttributeRenderer);

        if (isEmptyAttributeValue(rawValue, column)) {
          return [];
        }

        return {
          key: column.attribute,
          node: (
            <CardChipValue
              record={record}
              column={column}
              rawValue={rawValue}
              visual={getChipVisual(column, layout)}
              customAttributeRenderer={customAttributeRenderer}
              customComponentsByAttribute={customComponentsByAttribute}
            />
          ),
        };
      }),
    [chips, layout, record, customAttributeRenderers, customComponentsByAttribute],
  );
